var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpvoLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "152.012px",
    height: "141.655px",
    viewBox: "0 0 152.012 141.655",
    enableBackground: "new 0 0 152.012 141.655",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M9.994,66.957c0,5.521-4.478,9.991-9.994,9.991c-5.519,0-9.991-4.47-9.991-9.991S-5.519,56.962,0,56.962 C5.517,56.962,9.994,61.436,9.994,66.957"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-9.991,66.957c0,5.521-4.478,9.991-9.994,9.991c-5.519,0-9.991-4.47-9.991-9.991s4.473-9.995,9.991-9.995 C-14.469,56.962-9.991,61.436-9.991,66.957"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M78.768,5.977c-5.521,0-9.991-4.478-9.991-9.994c0-5.519,4.47-9.991,9.991-9.991s9.995,4.473,9.995,9.991 C88.762,1.499,84.289,5.977,78.768,5.977"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M78.768-14.009c-5.521,0-9.991-4.478-9.991-9.994c0-5.519,4.47-9.991,9.991-9.991s9.995,4.473,9.995,9.991 C88.762-18.486,84.289-14.009,78.768-14.009"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M181.991,66.957c0,5.521-4.478,9.991-9.994,9.991c-5.519,0-9.991-4.47-9.991-9.991s4.473-9.995,9.991-9.995 C177.513,56.962,181.991,61.436,181.991,66.957"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M162.005,66.957c0,5.521-4.478,9.991-9.994,9.991c-5.519,0-9.991-4.47-9.991-9.991s4.473-9.995,9.991-9.995 C157.528,56.962,162.005,61.436,162.005,66.957"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M78.768,178.036c-5.521,0-9.991-4.479-9.991-9.994c0-5.52,4.47-9.992,9.991-9.992s9.995,4.473,9.995,9.992 C88.762,173.558,84.289,178.036,78.768,178.036"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M78.768,158.05c-5.521,0-9.991-4.477-9.991-9.994s4.47-9.99,9.991-9.99s9.995,4.473,9.995,9.99 S84.289,158.05,78.768,158.05"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -29.97,
    y: -33.975,
    fill: "#FFFFFF",
    width: 211.777,
    height: 211.942
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#97BF0D",
    d: "M104.565,66.53c-20.543,2.872-34.955,21.609-32.6,42.105c1.366,0.149,2.752,0.233,4.159,0.233 c20.759,0,37.588-16.829,37.588-37.588c0-1.679-0.121-3.329-0.334-4.949C110.5,66.065,107.55,66.115,104.565,66.53"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#57AB27",
    d: "M77.569,82.179c-9.25-7.584-15.216-6.652-21.523-16.939c-7.186-11.72-1.09-23.062,1.012-26.351 c-11.084,6.536-18.523,18.593-18.523,32.393c0,20.758,16.828,37.587,37.589,37.587c3.193,0,6.294-0.4,9.255-1.149 C86.506,103.991,89.092,91.628,77.569,82.179"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E53138",
    d: "M88.596,56.966c0,5.521-4.478,9.991-9.995,9.991c-5.518,0-9.991-4.47-9.991-9.991s4.473-9.995,9.991-9.995 C84.119,46.971,88.596,51.445,88.596,56.966"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009435",
    d: "M78.944,108.754c0.53-0.039,1.061-0.089,1.585-0.149c0.217-0.027,0.431-0.053,0.645-0.082 c0.547-0.074,1.09-0.16,1.629-0.255c0.164-0.03,0.329-0.057,0.494-0.089c0.7-0.136,1.395-0.288,2.082-0.459 c1.1-3.646,3.587-15.524-7.043-24.881c-4.982,7.312-7.455,16.365-6.371,25.797c0.68,0.075,1.366,0.134,2.055,0.172 c0.004,0,0.006,0.003,0.01,0.003c0.692,0.038,1.391,0.059,2.094,0.059c0.737,0,1.468-0.027,2.196-0.068 C78.529,108.79,78.736,108.77,78.944,108.754"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCC00",
    points: "76.135,5.977 77.619,10.548 82.427,10.548 78.54,13.373 80.024,17.945 76.135,15.122  72.245,17.945 73.731,13.373 69.842,10.548 74.649,10.548  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCC00",
    points: "47.009,13.559 48.494,18.129 53.3,18.129 49.412,20.956 50.897,25.525 47.009,22.704  43.12,25.525 44.607,20.956 40.716,18.129 45.522,18.129  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCC00",
    points: "24.267,35.104 25.753,39.676 30.56,39.676 26.668,42.5 28.156,47.073 24.267,44.25 20.377,47.073  21.862,42.5 17.976,39.676 22.782,39.676  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCC00",
    points: "16.287,65.023 17.772,69.6 22.579,69.6 18.689,72.425 20.177,76.998 16.287,74.17 12.397,76.998  13.884,72.425 9.994,69.6 14.801,69.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCC00",
    points: "24.666,94.55 26.149,99.123 30.958,99.123 27.069,101.947 28.555,106.523 24.666,103.696  20.774,106.523 22.264,101.947 18.373,99.123 23.18,99.123  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCC00",
    points: "46.21,117.294 47.696,121.865 52.503,121.865 48.613,124.69 50.1,129.261 46.21,126.438  42.321,129.261 43.807,124.69 39.918,121.865 44.725,121.865  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCC00",
    points: "76.135,125.674 77.619,130.245 82.427,130.245 78.54,133.07 80.024,137.641 76.135,134.817  72.245,137.641 73.731,133.07 69.842,130.245 74.649,130.245  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCC00",
    points: "106.456,116.498 107.942,121.064 112.752,121.064 108.859,123.893 110.345,128.467  106.456,125.638 102.568,128.467 104.055,123.893 100.165,121.064 104.97,121.064  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCC00",
    points: "127.725,95.542 129.209,100.113 134.016,100.113 130.127,102.938 131.615,107.512  127.725,104.686 123.834,107.512 125.322,102.938 121.432,100.113 126.239,100.113  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCC00",
    points: "135.959,64.87 137.445,69.443 142.252,69.443 138.36,72.269 139.849,76.84 135.959,74.016  132.07,76.84 133.558,72.269 129.667,69.443 134.473,69.443  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCC00",
    points: "128.778,35.348 130.264,39.917 135.073,39.917 131.179,42.744 132.665,47.316 128.778,44.494  124.89,47.316 126.375,42.744 122.487,39.917 127.294,39.917  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFCC00",
    points: "106.436,13.007 107.918,17.575 112.729,17.575 108.839,20.403 110.325,24.974 106.436,22.148  102.546,24.974 104.034,20.403 100.141,17.575 104.951,17.575  "
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "guides"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpvoLogo);
export default __webpack_public_path__ + "static/media/cpvo_logo.d4c54555d31725171beda9145c8c342c.svg";
export { ForwardRef as ReactComponent };